






















































import { Vue, Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { Modules } from '../../store/store';
import { BoundingBox } from '@/store/modules/config';

const configModule = namespace(Modules.config);

@Component({ name: 'ctc-battery-cell-layers' })
export default class BatteryCellLayers extends Vue {
  private cellWidth = 0;
  private cellBorderWidth = 0;

  @Prop({ type: Number, default: 10 })
  private readonly numberOfCells!: number;

  @Prop({ type: Number, required: true })
  private readonly chargingValue!: number;

  @Prop({ type: Number, default: 0 })
  private readonly chargingValueStart!: number;

  @Prop({ type: String })
  private readonly lastHandleChange = undefined;

  @Prop({ required: true })
  private readonly borderImageRef!: () => { clientWidth: number };

  @configModule.Getter('hasBatteryStartSlider')
  private readonly hasBatteryStartSlider!: boolean;

  @configModule.Getter('appBoundingBox')
  private readonly appBoundingBox!: BoundingBox;

  protected async mounted(): Promise<void> {
    await this.$nextTick();
    this.calcCellWidth();
  }

  @Watch('appBoundingBox')
  public appBoundingBoxChanged(): void {
    this.calcCellWidth();
  }

  private calcCellWidth() {
    const cellWidthDivider = 16;
    const cellBorderWidthDivider = 48;
    const borderImageWidth = this.borderImageRef().clientWidth;
    if (borderImageWidth) {
      this.cellWidth = borderImageWidth / cellWidthDivider;
      this.cellBorderWidth = borderImageWidth / cellBorderWidthDivider;
    }
  }

  private startSliderChanged(): number {
    if (this.chargingValueStart) {
      if (this.lastHandleChange === 'chargingValue' && this.chargingValue < this.chargingValueStart) {
        return this.chargingValue;
      }
      if (this.lastHandleChange === 'chargingValueStart' && this.chargingValueStart > this.chargingValue) {
        return this.chargingValueStart;
      }
      return this.chargingValueStart;
    } else {
      return 0;
    }
  }
}
